import { Skeleton } from '../ui/skeleton';

const shimmer = 'bg-ocean/5';

export const ScheduleSkeleton = () => (
  <div className="space-y-6 animate-in fade-in duration-300" data-testid="skeleton-schedule">
    {[1, 2, 3].map(day => (
      <div key={day} className="bg-white/90 backdrop-blur-xl rounded-2xl border border-white/30 p-6 shadow-md">
        <div className="flex items-center gap-3 mb-5">
          <Skeleton className={`w-10 h-10 rounded-full ${shimmer}`} />
          <Skeleton className={`h-6 w-40 ${shimmer}`} />
          <Skeleton className={`h-5 w-24 ml-auto rounded-full ${shimmer}`} />
        </div>
        {['Morning', 'Afternoon', 'Evening'].map(t => (
          <div key={t} className="mb-4 ml-4 pl-4 border-l-2 border-ocean/10">
            <Skeleton className={`h-4 w-20 mb-2 ${shimmer}`} />
            <Skeleton className={`h-5 w-3/4 mb-1 ${shimmer}`} />
            <Skeleton className={`h-4 w-1/2 ${shimmer}`} />
          </div>
        ))}
      </div>
    ))}
  </div>
);

export const LodgingSkeleton = () => (
  <div className="space-y-4 animate-in fade-in duration-300" data-testid="skeleton-lodging">
    {[1, 2].map(i => (
      <div key={`skel-${i}`} className="bg-white/90 backdrop-blur-xl rounded-2xl border border-white/30 p-6 shadow-md flex gap-5">
        <Skeleton className={`w-32 h-32 rounded-xl shrink-0 ${shimmer}`} />
        <div className="flex-1 space-y-3">
          <Skeleton className={`h-6 w-48 ${shimmer}`} />
          <Skeleton className={`h-4 w-32 ${shimmer}`} />
          <Skeleton className={`h-4 w-full ${shimmer}`} />
          <Skeleton className={`h-4 w-2/3 ${shimmer}`} />
          <div className="flex gap-2 mt-2">
            <Skeleton className={`h-8 w-24 rounded-full ${shimmer}`} />
            <Skeleton className={`h-8 w-28 rounded-full ${shimmer}`} />
          </div>
        </div>
      </div>
    ))}
  </div>
);

export const TransportSkeleton = () => (
  <div className="space-y-4 animate-in fade-in duration-300" data-testid="skeleton-transport">
    {[1, 2, 3].map(i => (
      <div key={`skel-${i}`} className="bg-white/90 backdrop-blur-xl rounded-2xl border border-white/30 p-5 shadow-md">
        <div className="flex items-center gap-4">
          <Skeleton className={`w-12 h-12 rounded-full ${shimmer}`} />
          <div className="flex-1 space-y-2">
            <Skeleton className={`h-5 w-44 ${shimmer}`} />
            <Skeleton className={`h-4 w-64 ${shimmer}`} />
          </div>
          <Skeleton className={`h-6 w-20 rounded-full ${shimmer}`} />
        </div>
      </div>
    ))}
  </div>
);

export const VisaSkeleton = () => (
  <div className="bg-white/90 backdrop-blur-xl rounded-2xl border border-white/30 p-6 shadow-md space-y-5 animate-in fade-in duration-300" data-testid="skeleton-visa">
    <div className="flex items-center gap-3">
      <Skeleton className={`w-10 h-10 rounded-full ${shimmer}`} />
      <Skeleton className={`h-6 w-52 ${shimmer}`} />
    </div>
    <div className="grid grid-cols-2 gap-4">
      {[1, 2, 3, 4].map(i => (
        <div key={`skel-${i}`} className="space-y-2 p-4 bg-sky/5 rounded-lg">
          <Skeleton className={`h-4 w-24 ${shimmer}`} />
          <Skeleton className={`h-5 w-36 ${shimmer}`} />
        </div>
      ))}
    </div>
    <div className="space-y-2">
      <Skeleton className={`h-4 w-full ${shimmer}`} />
      <Skeleton className={`h-4 w-5/6 ${shimmer}`} />
      <Skeleton className={`h-4 w-3/4 ${shimmer}`} />
    </div>
  </div>
);

export const TipsSkeleton = () => (
  <div className="space-y-4 animate-in fade-in duration-300" data-testid="skeleton-tips">
    {[1, 2, 3].map(i => (
      <div key={`skel-${i}`} className="bg-white/90 backdrop-blur-xl rounded-2xl border border-white/30 p-5 shadow-md">
        <div className="flex items-start gap-3">
          <Skeleton className={`w-8 h-8 rounded-lg shrink-0 ${shimmer}`} />
          <div className="flex-1 space-y-2">
            <Skeleton className={`h-5 w-40 ${shimmer}`} />
            <Skeleton className={`h-4 w-full ${shimmer}`} />
            <Skeleton className={`h-4 w-4/5 ${shimmer}`} />
          </div>
        </div>
      </div>
    ))}
  </div>
);

export const WeatherSkeleton = () => (
  <div className="bg-white/90 backdrop-blur-xl rounded-2xl border border-white/30 p-6 shadow-md space-y-5 animate-in fade-in duration-300" data-testid="skeleton-weather">
    <div className="flex items-center gap-3 mb-2">
      <Skeleton className={`w-10 h-10 rounded-full ${shimmer}`} />
      <Skeleton className={`h-6 w-44 ${shimmer}`} />
    </div>
    <div className="grid grid-cols-3 md:grid-cols-5 gap-3">
      {[1, 2, 3, 4, 5].map(i => (
        <div key={`skel-${i}`} className="p-4 bg-sky/5 rounded-xl text-center space-y-2">
          <Skeleton className={`h-4 w-12 mx-auto ${shimmer}`} />
          <Skeleton className={`h-10 w-10 mx-auto rounded-full ${shimmer}`} />
          <Skeleton className={`h-6 w-16 mx-auto ${shimmer}`} />
          <Skeleton className={`h-3 w-20 mx-auto ${shimmer}`} />
        </div>
      ))}
    </div>
  </div>
);

export const InsuranceSkeleton = () => (
  <div className="space-y-4 animate-in fade-in duration-300" data-testid="skeleton-insurance">
    <div className="bg-white/90 backdrop-blur-xl rounded-2xl border border-white/30 p-6 shadow-md">
      <div className="flex items-center gap-3 mb-4">
        <Skeleton className={`w-10 h-10 rounded-full ${shimmer}`} />
        <Skeleton className={`h-6 w-48 ${shimmer}`} />
      </div>
      <div className="grid grid-cols-2 gap-4">
        {[1, 2, 3, 4].map(i => (
          <div key={`skel-${i}`} className="p-4 bg-sky/5 rounded-lg space-y-2">
            <Skeleton className={`h-4 w-28 ${shimmer}`} />
            <Skeleton className={`h-5 w-20 ${shimmer}`} />
          </div>
        ))}
      </div>
    </div>
  </div>
);

export const GallerySkeleton = () => (
  <div className="space-y-4 animate-in fade-in duration-300" data-testid="skeleton-gallery">
    <Skeleton className={`h-6 w-36 mb-4 ${shimmer}`} />
    <div className="grid grid-cols-3 md:grid-cols-4 gap-3">
      {[1, 2, 3, 4, 5, 6, 7, 8].map(i => (
        <Skeleton key={`skel-${i}`} className={`aspect-square rounded-xl ${shimmer}`} />
      ))}
    </div>
  </div>
);

export const CompanionsSkeleton = () => (
  <div className="bg-white/90 backdrop-blur-xl rounded-2xl border border-white/30 p-6 shadow-md space-y-4 animate-in fade-in duration-300" data-testid="skeleton-companions">
    <div className="flex items-center justify-between mb-4">
      <Skeleton className={`h-6 w-36 ${shimmer}`} />
      <Skeleton className={`h-9 w-32 rounded-full ${shimmer}`} />
    </div>
    {[1, 2].map(i => (
      <div key={`skel-${i}`} className="flex items-center gap-4 p-3 bg-sky/5 rounded-lg">
        <Skeleton className={`w-10 h-10 rounded-full ${shimmer}`} />
        <div className="flex-1 space-y-2">
          <Skeleton className={`h-5 w-32 ${shimmer}`} />
          <Skeleton className={`h-4 w-44 ${shimmer}`} />
        </div>
        <Skeleton className={`h-6 w-16 rounded-full ${shimmer}`} />
      </div>
    ))}
  </div>
);

export const JournalSkeleton = () => (
  <div className="bg-white/90 backdrop-blur-xl rounded-2xl border border-white/30 p-6 shadow-md space-y-5 animate-in fade-in duration-300" data-testid="skeleton-journal">
    <div className="flex items-center justify-between">
      <Skeleton className={`h-6 w-40 ${shimmer}`} />
      <Skeleton className={`h-9 w-36 rounded-full ${shimmer}`} />
    </div>
    <Skeleton className={`h-24 w-full rounded-xl border-2 border-dashed border-ocean/10 ${shimmer}`} />
    <div className="grid grid-cols-3 md:grid-cols-4 gap-3">
      {[1, 2, 3, 4].map(i => (
        <Skeleton key={`skel-${i}`} className={`aspect-square rounded-xl ${shimmer}`} />
      ))}
    </div>
  </div>
);

const SKELETON_MAP = {
  schedule: ScheduleSkeleton,
  lodging: LodgingSkeleton,
  transport: TransportSkeleton,
  visa: VisaSkeleton,
  tips: TipsSkeleton,
  weather: WeatherSkeleton,
  insurance: InsuranceSkeleton,
  gallery: GallerySkeleton,
  companions: CompanionsSkeleton,
  journal: JournalSkeleton,
};

export const TabSkeleton = ({ tab }) => {
  const Component = SKELETON_MAP[tab];
  return Component ? <Component /> : null;
};
